import { test, enforce, create } from 'vest'

const newTagFormValidation = create((data = {}) => {
  const { newTag } = data

  test('newTag', 'You must enter the Name', () => {
    enforce(newTag).isNotEmpty()
  })
})

const camalize = (str: string) => {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())
}

export default {
  camalize,
  newTagFormValidation,
}
